import dayjs from 'lib/dayjs';

export const LEAVE_TYPES = {
  FULL_DAY: 'FULL_DAY_LEAVE',
  HALF_DAY: 'HALF_DAY_LEAVE',
  LONG_TIME: 'LONG_TIME_LEAVE',
  SHORT: 'SHORT_LEAVE',
  MULTIPLE_DAY: 'MULTIPLE_DAY_LEAVE',
};

export const mapLeaveType = (leaveType) => {
  switch (leaveType) {
    case LEAVE_TYPES.FULL_DAY:
      return 'Full Day Leave';
    case LEAVE_TYPES.HALF_DAY:
      return 'Half Day Leave';
    case LEAVE_TYPES.LONG_TIME:
      return 'Long Time Leave';
    case LEAVE_TYPES.SHORT:
      return 'Short Leave';
    case LEAVE_TYPES.MULTIPLE_DAY:
      return 'Multiple Day Leave';
    default:
      return leaveType || 'Unknown';
  }
};

export function getRoundingAdjustment(amount) {
  const roundedAmount = Math.round(amount);
  const adjustment = Number((roundedAmount - amount).toFixed(2));
  return adjustment > 0 ? `+${adjustment.toFixed(2)}` : adjustment.toFixed(2);
}

export const getOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
export const getDaysInMonth = (year, month) => {
  return new Date(year, month, 0).getDate();
};
export const getLeaveTypeEnum = (displayString) => {
  switch (displayString) {
    case 'Full Day Leave':
      return LEAVE_TYPES.FULL_DAY;
    case 'Half Day Leave':
      return LEAVE_TYPES.HALF_DAY;
    case 'Long Time Leave':
      return LEAVE_TYPES.LONG_TIME;
    case 'Short Leave':
      return LEAVE_TYPES.SHORT;
    case 'Multiple Day Leave':
      return LEAVE_TYPES.MULTIPLE_DAY;
    default:
      return displayString;
  }
};

export const mapLeaveStatus = (status) => {
  switch (status) {
    case 'PENDING':
      return 'Pending';
    case 'APPROVED':
      return 'Approved';
    case 'REJECTED':
      return 'Rejected';
    case 'CANCELLED':
      return 'Cancelled';
    default:
      return status || 'Unknown';
  }
};

export const getEmployeeDisplayName = (leave) => {
  const { first_name, last_name, employee_id } = leave?.user || {};
  const employeeName = first_name + ' ' + last_name || 'Unknown Employee';
  return `${employeeName} - ${employee_id}`;
};

export const formatLeaveTypeDisplay = (leave) => {
  if (leave?.type === LEAVE_TYPES.HALF_DAY && leave?.halfDayType) {
    return leave?.halfDayType === 'first' ? 'First Half Day Leave' : 'Second Half Day Leave';
  }
  return mapLeaveType(leave?.type);
};

export const getAllSundays = (year, month) => {
  const sundays = [];

  let date = dayjs(`${year}-${month}-01`);
  const today = dayjs();

  while (date.isBefore(today) || date.isSame(today, 'day')) {
    if (date.day() === 0) {
      // 0 = Sunday
      sundays.push(date.format('YYYY-MM-DD'));
    }
    date = date.add(1, 'day');
  }

  return sundays;
};
export function shortenHash(hash, start = 6, end = 6) {
  if (hash.length <= start + end) return hash;
  return `${hash.slice(0, start)}...${hash.slice(-end)}`;
}

export const formatDate = (date) => {
  if (!date) return '';
  return dayjs(date).format('DD MMM, YYYY');
};

export const PUBLIC_ROUTES = ['/', '/login-register'];

export const formatDateTime = (dateTime) => {
  if (!dateTime) return '';
  return dayjs(dateTime).format('DD MMM, YYYY hh:mm A');
};

// Multi-word name search: every word in the query must match the first, middle or
// last name or the employee ID, so "Aarav Shah" matches first + last name.
export const matchesNameSearch = (person, query) => {
  const terms = (query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const fields = [person?.first_name, person?.middle_name, person?.last_name, person?.employee_id]
    .filter(Boolean)
    .map((field) => String(field).toLowerCase());
  return terms.every((term) => fields.some((field) => field.includes(term)));
};
